import UsersRoutes from '@/pages/teacher/components/user/router';

export default [
  {
    path: 'teacher',
    component: () => import('@/pages/teacher/Teacher'),
    meta: {
      requiresAuth: true,
      role: 'teacher',
    },
    children: [
      {
        path: '',
        redirect: 'users',
      },
     ...UsersRoutes,
    ]
  },
];
